<template>
  <div>
    <section class="my-2" style="padding-bottom: 40px" id="#matricula">
      <h2 class="font-weight-bold text-center py-5">Matrícula</h2>
      <div class="container">

        <form class="row" @submit.prevent="validate">
          <div class="col-12 col-md-6">
            <h4 class="form-title">Dados de acesso</h4>

            <div class="form-group">
              <label for="cartaoNome">Nome do Titular: *</label>
              <input
                v-model="customerProfile.customer_card_name"
                type="text"
                class="form-control"
                id="cartaoNome"
                autocomplete="off"
                placeholder="Ex. GEORGE D MELO"
                required
              />
            </div>

            <div class="form-group">
              <label for="email">E-mail: *</label>
              <input
                v-model="studentProfile.email"
                v-on:input="checkEmail()"
                type="email"
                :class="email.type==='error'?'has-error':''"
                class="form-control"
                id="email"
                placeholder="seu e-mail"
                required
              />
            </div>
            <label class="text-danger" v-if="email.type==='error'">{{ email.message }}</label>
            <div class="form-group">
              <label for="cellphone">Celular (com DDD): *</label>
              <input
                v-model="studentProfile.cellphone"
                type="text"
                class="form-control"
                id="cellphone"
                placeholder="Ex: (99) 9999-9999"
                required
              />
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="password">Senha: *</label>
                  <input
                    v-model="studentProfile.password"
                    type="password"
                    class="form-control"
                    id="password"
                    autocomplete="off"
                    placeholder="Mínimo de 6 dígitos"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="password2">Confirmar Senha: *</label>
                  <input
                    v-model="studentProfile.password_confirmation"
                    type="password"
                    class="form-control"
                    id="password2"
                    autocomplete="off"
                    placeholder="Repita sua senha"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <h4 class="form-title">Dados de pagamento</h4>
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <label>Cartão de Crédito:</label>
                <br />
                <el-select
                  class="select-start"
                  required
                  v-model="customerProfile.customer_card_type"
                  placeholder="Selecione..."
                  @change="setCreditCardType()"
                >
                  <el-option
                    v-for="(option) in cardTypes"
                    class="select-danger"
                    :value="option"
                    :label="option"
                    :key="option"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-8 col-sm-12">
                <div class="form-group">
                  <label>Número do cartāo: *</label>
                  <input
                    v-model="customerProfile.customer_card_number"
                    type="text"
                    class="form-control"
                    autocomplete="off"
                    placeholder="xxxx xxxx xxxx xxxx"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4" style="padding-left: 15x; padding-right: 0px;">
                <label for="cartaoVencimento">Mês de Vencimento: *</label>
                <br />
                <el-select
                  required
                  style="padding-left: 0px; padding-right: 0px;"
                  class="col-11 select-start"
                  id="cartaoVencimento"
                  v-model="customerProfile.customer_card_expiry_month"
                  placeholder="Selecione..."
                >
                  <el-option
                    v-for="(option) in monthsOfTheYear"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="option"
                  ></el-option>
                </el-select>
              </div>

              <div class="col-4" style="padding-left: 15px; padding-right: 0px;">
                <label for="cartaoValidade">Ano de Vencimento: *</label>
                <br />
                <el-select
                  style="padding-left: 0px; padding-right: 0px;"
                  class="col-10 select-start"
                  required
                  id="cartaoValidade"
                  v-model="customerProfile.customer_card_expiry_year"
                  placeholder="Selecione..."
                >
                  <el-option
                    v-for="(option) in TenYearsFromNow"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="option"
                  ></el-option>
                </el-select>
                <!-- <input type="text" class="form-control" id="cartaoValidade" autocomplete="off"
                placeholder="xx/xx" required>-->
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label>CVV: * &nbsp &nbsp &nbsp &nbsp &nbsp &nbsp &nbsp &nbsp &nbsp</label>
                  <input
                    minlength="3"
                    maxlength="4"
                    v-model="customerProfile.customer_card_cvc"
                    type="text"
                    class="form-control"
                    autocomplete="off"
                    placeholder="Cod. segurança (3 ou 4 dígitos)"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="col-12">
              <br />
              <div class="row d-flex justify-content-between">
                <p>
                  <a href="/#/politica_de_privacidade" target="_blanck">Politica de Privacidade </a>
                </p>
                <p>
                  <a href="https://res.cloudinary.com/toptrader/image/upload/v1594930702/CONTRATO_E_TERMOS_E_CONDI%C3%87%C3%95ES_DA_ASSINATURA_START_1_ussgd7.pdf" >
                    Termos e Condições
                  </a>
                </p>
              </div>
              <div class="form-group custom-control custom-checkbox d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="checkbox"
                  required
                  v-model="agreeWithToS"
                />
                <label
                  class="custom-control-label"
                  for="checkbox"
                >
                  Aceito os termos de serviço e o contrato de prestação de serviço no valor de R$99,90 por mês, sendo a primeira parcela no valor de R$199,90, durante uma fidelidade de 12 meses renovado automaticamente
                </label>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row text-danger">
              <p v-if="formErrors.length">
                <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
              </p>
              <ul>
                <li v-for="error in formErrors" :key="error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div
            class="col-12"
            v-if="loadingRegistration"
            v-loading="loadingRegistration"
            id="loading"
          ></div>
          <div class="col-lx-12 col-md-12" v-if="!loadingRegistration">
            <div class="form-group d-flex justify-content-center centered mt-4">
              <button type="submit" class="btn-other my-5 py-2 px-5">FINALIZAR MATRÍCULA</button>
            </div>
          </div>
        </form>
        <br />
      </div>
    </section>

    <section id="copy" style="background: #141414">
      <div class="container">
        <p class="text" style="font-size: 12px">Informações e Condições:</p>
        <p class="text" style="font-size: 12px">
          TODO E QUALQUER INVESTIMENTO POSSUI UM RISCO, NEGOCIAÇÕES NO MERCADO FINANCEIRO SÃO ALTAMENTE
          ESPECULATIVAS, ACARRETAM UM ALTO NÍVEL DE RISCO, O QUAL PODERÁ NÃO SER ADEQUADO PARA TODOS OS
          INVESTIDORES. OS QUAIS PODERÃO SOFRER UMA PERDA DE PARTE OU DE TODO O CAPITAL INVESTIDO. POR
          CONSEGUINTE, NÃO DEVE ESPECULAR COM CAPITAL QUE NÃO SE PODE DAR AO LUXO DE PERDER.
        </p>

        <p class="text" style="font-size: 10px">
          A TOPTRADER NÃO É UMA CORRETORA E TAMBÉM NÃO REPRESENTA NENHUMA, NÃO GERENCIAMOS CONTAS DE TERCEIROS.
          TOPTRADER É UM NOME FANTASIA DA TOP TRADER CURSOS E TREINAMENTOS, UMA EMPRESA DE PRESTAÇÃO DE SERVIÇOS
          DE TREINAMENTO EM DESENVOLVIMENTO PROFISSIONAL E GERENCIAL, REGULAMENTADA PELA RECEITA FEDERAL NO BRASIL
          COM CNPJ 22.147.162/0001-90. NÃO POSSUÍMOS VINCULO COM INSTITUIÇÕES PARA CAPTAÇÃO DE CLIENTES.
        </p>
      </div>
    </section>
    <footer style="margin-bottom: 0rem">
      <div class="layer-1">
        <div class="container">
          <div class="wrapper">
            <small>&copy; 2021. Ever Investor - Todos os direitos reservados</small>

            <div class="social">
              <a href="https://everinvestor.com.br/facebook" target="_blank" rel="noopener">
                <img
                  src="static/img/icons/facebook.svg"
                  target="_blank"
                  alt="https://www.facebook.com/TopTraderOrg"
                />
              </a>

              <a href="https://everinvestor.com.br/instagram" target="_blank" rel="noopener">
                <img
                  src="static/img/icons/instagram.svg"
                  target="_blank"
                  alt="https://www.instagram.com/toptraderorg/"
                />
              </a>

              <a href="https://everinvestor.com.br/youtube" target="_blank" rel="noopener">
                <img
                  src="static/img/icons/youtube.svg"
                  target="_blank"
                  alt="https://www.youtube.com/user/TopTraderCanal"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  Loading,
  Select,
  Option,
  Dialog,
  Table,
  TableColumn,
  MessageBox,
  Collapse,
  CollapseItem
} from 'element-ui'
import { mask } from 'vue-the-mask'
import { Checkbox, FadeRenderTransition } from 'src/components/index'
import AuthLayout from './AuthLayout.vue'
import swal from 'sweetalert2'
import Swiper from 'swiper'
import moment from 'moment'
import { Timeline, TimelineItem } from 'vue-cute-timeline'
!(function (f, b, e, v, n, t, s) {
  if (f.fbq) return; n = f.fbq = function () {
    n.callMethod
  ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!f._fbq)f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'
  n.queue = []; t = b.createElement(e); t.async = !0
  t.src = v; s = b.getElementsByTagName(e)[0]
  s.parentNode.insertBefore(t, s)
}(window, document, 'script',
  'https://connect.facebook.net/en_US/fbevents.js'))
fbq('init', '1966427166953471')
fbq('track', 'PageView')
Vue.use(Loading.directive)
Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)

export default {
  components: {
    Checkbox,
    Timeline,
    TimelineItem,
    FadeRenderTransition,
    AuthLayout,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  directives: { mask },
  data () {
    return {
      toptrader: [
        { text: '1. Assine Acesso imediato à plataforma que ensina como compor e multiplicar seu capital de qualquer lugar do mundo.'},
        { text: '1. Assine Acesso imediato à plataforma que ensina como compor e multiplicar seu capital de qualquer lugar do mundo.'},
        { text: '1. Assine Acesso imediato à plataforma que ensina como compor e multiplicar seu capital de qualquer lugar do mundo.'}
      ],
      planVindi: {
        plan_items: [
          {
            pricing_schema: {
              short_format: ''
            }
          }
        ]
      },
      modals: {
        centered: false
      },
      agreeWithToS: false,
      formErrors: [],
      successMessage: '',
      loadingRegistration: false,
      email: {
        type: false,
        message: ''
      },
      studentProfile: {
        email: '',
        password: '',
        password_confirmation: '',
        cellphone: ''
      },
      monthsOfTheYear: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      TenYearsFromNow: [],
      cardTypes: [
        'visa',
        'mastercard',
        'diners_club',
        'american_express',
        'elo'
      ],
      creditCardMask: '',
      cvcMask: '',
      stateIndex: 0,
      customerProfile: {
        customer_card_number: '',
        customer_card_type: '',
        customer_card_name: '',
        customer_card_expiry_month: '',
        customer_card_expiry_year: '',
        customer_card_cvc: ''
      },
      mainSwiper: null,
      benefitsSwiper: null,
      testDate: 0
    }
  },
  mounted () {
    for (
      var i = parseInt(new Date().getFullYear(), 10);
      i <= parseInt(new Date().getFullYear(), 10) + 10;
      i++
    ) {
      this.TenYearsFromNow.push(i)
    }
    this.axios
      .get('/vindi/' + process.env.VUE_APP_VINDI_PLANPROMOTIONAL)
      .then(response => {
        this.planVindi = response.data
      })
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    openModal (centered) {
      this.modals[centered] = true
    },
    closeModal (centered) {
      this.modals[centered] = false
    },
    next () {
      this.$refs.slick.next()
    },

    prev () {
      this.$refs.slick.prev()
    },
    reInit () {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },
    handleAfterChange (event, slick, currentSlide) {
      console.log('handleAfterChange', event, slick, currentSlide)
    },
    handleBeforeChange (event, slick, currentSlide, nextSlide) {
      console.log('handleBeforeChange', event, slick, currentSlide, nextSlide)
    },
    handleBreakpoint (event, slick, breakpoint) {
      console.log('handleBreakpoint', event, slick, breakpoint)
    },
    handleDestroy (event, slick) {
      console.log('handleDestroy', event, slick)
    },
    handleEdge (event, slick, direction) {
      console.log('handleEdge', event, slick, direction)
    },
    handleInit (event, slick) {
      console.log('handleInit', event, slick)
    },
    handleReInit (event, slick) {
      console.log('handleReInit', event, slick)
    },
    handleSetPosition (event, slick) {
      console.log('handleSetPosition', event, slick)
    },
    handleSwipe (event, slick, direction) {
      console.log('handleSwipe', event, slick, direction)
    },
    handleLazyLoaded (event, slick, image, imageSource) {
      console.log('handleLazyLoaded', event, slick, image, imageSource)
    },
    handleLazeLoadError (event, slick, image, imageSource) {
      console.log('handleLazeLoadError', event, slick, image, imageSource)
    },
    checkEmail () {
      if (this.validEmail(this.studentProfile.email)) {
        this.axios
          .get('/student/check/email/' + this.studentProfile.email)
          .then(response => {
            if (response.data) {
              this.email = response.data
            }
          })
          .catch(error => {
            this.email.type = 'error'
            this.email.message =
              'Erro ao validar e-mail informado. Entre em contato com suporte.'
            console.log(error)
          })
      }
    },
    wizardComplete () {
      var paymentProfile = {
        holder_name: this.customerProfile.customer_card_name,
        card_expiration:
          this.customerProfile.customer_card_expiry_month +
          '/' +
          this.customerProfile.customer_card_expiry_year,
        card_number: this.customerProfile.customer_card_number,
        card_cvv: this.customerProfile.customer_card_cvc,
        payment_method_code: 'credit_card',
        payment_company_code: this.customerProfile.customer_card_type
      }

      this.loadingRegistration = true

      // set vindi's public key.
      const VINDI_PUBKEY = process.env.VUE_APP_VINDI_PUBKEY
      const VINDI_URL = process.env.VUE_APP_VINDI_URL
      const PLAN_ID = 187672

      this.axios({
        method: 'post',
        url: VINDI_URL + 'public/payment_profiles',
        dataType: 'json',
        headers: {
          Authorization: 'Basic ' + btoa(VINDI_PUBKEY + ':')
        },
        data: paymentProfile
      })
        .then(response => {
          this.studentProfile.name = this.customerProfile.customer_card_name
          this.customerProfile.customer_card_name = ''
          this.customerProfile.customer_card_number = ''
          this.customerProfile.customer_card_cvc = ''
          this.customerProfile.customer_card_expiry_month = ''
          this.customerProfile.customer_card_expiry_year = ''
          this.customerProfile.customer_card_type = ''

          let wizard = {
            ...this.studentProfile,
            ...response.data.payment_profile,
            planId: PLAN_ID
          }

          this.axios
            .patch('/vindi/start', wizard)
            .then(response => {
              this.loadingRegistration = false
              if (response.status == '200') {
                swal({
                  title:
                    response.data.type !== 'error'
                      ? 'Inscrição realizada com sucesso!'
                      : 'Ops!',
                  text: '' + response.data.message,
                  type: '' + response.data.type,
                  confirmButtonText: 'Ok!',
                  confirmButtonColor: '#002c44'
                }).then(result => {
                  if (response.data.type !== 'error') {
                    let vm = this
                    setTimeout(function () {
                      window.location.href = 'https://top-trader.org/obrigado'
                    }, 100)
                  }
                })
              }
            })
            .catch(error => {
              this.loadingRegistration = false
              swal({
                title: 'Falha ao processar inscrição!',
                text: 'Entre em contato com o suporte.',
                type: 'error',
                confirmButtonText: 'Ok! Ir para Chat',
                confirmButtonColor: '#FB404B'
              }).then(result => {
                setTimeout(function () {
                  window.location.href =
                    'https://api.whatsapp.com/send?phone=5591991133258'
                }, 100)
              })
            })
        })
        .catch(error => {
          this.loadingRegistration = false
          swal({
            title: 'Cartão Recusado!',
            text:
              'Verifique os dados de pagamento ou entre em contato com sua administradora de cartões',
            type: 'error',
            confirmButtonText: 'Ok! Tentar Novamente',
            confirmButtonColor: '#FB404B'
          })
          console.log(error)
        })
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validate () {
      this.formErrors = []

      if (!this.agreeWithToS) {
        this.formErrors.push(
          'É necessário concordar com os termos e contrato de prestação de serviço antes prosseguir.'
        )
      }

      if (
        !this.studentProfile.email ||
        !this.studentProfile.password ||
        !this.studentProfile.password_confirmation ||
        !this.customerProfile.customer_card_number ||
        !this.customerProfile.customer_card_type ||
        !this.customerProfile.customer_card_name ||
        !this.customerProfile.customer_card_expiry_month ||
        !this.customerProfile.customer_card_expiry_year ||
        !this.customerProfile.customer_card_cvc ||
        !this.studentProfile.cellphone
      ) {
        this.formErrors.push(
          'Todos os campos devem ser preenchidos obrigatoriamente.'
        )
        return false
      }

      if (!this.validEmail(this.studentProfile.email)) {
        this.formErrors.push('Utilize um e-mail válido.')
      }

      if (!this.customerProfile.customer_card_type) {
        this.formErrors.push('Número de cartão inválido.')
      }

      if (this.studentProfile.password.length < 6) {
        this.formErrors.push('Campo senha deve conter no mínimo 6 caracteres.')
      }

      if (
        this.studentProfile.password !==
        this.studentProfile.password_confirmation
      ) {
        this.formErrors.push(
          'A senha de confirmação devem ser igual a senha definida.'
        )
      }
      if (this.formErrors.length === 0) {
        this.wizardComplete()
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    setCreditCardType () {
      switch (this.customerProfile.customer_card_type) {
        case 'visa':
          this.creditCardMask = 'XXXX XXXX XXXX XXXX'
          this.cvcMask = 'XXX'
          break
        case 'mastercard':
          this.creditCardMask = 'XXXX XXXX XXXX XXXX'
          this.cvcMask = 'XXX'
          break
        case 'diners_club':
          this.creditCardMask = 'XXXX XXXXXX XXXX'
          this.cvcMask = 'XXX'
          break
        case 'american_express':
          this.creditCardMask = 'XXXX XXXXXX XXXXX'
          this.cvcMask = 'XXXX'
          break
        case 'elo':
          this.creditCardMask = 'XXXX XXXX XXXX XXXX'
          this.cvcMask = 'XXX'
          break
      }
    }
  }
}
</script>
<style scoped src="@/assets/css/custom.css">
</style>
<style scoped >
h1 {
  font-size: 60px !important;
}
h2 {
  font-size: 45px !important;
}
h3 {
  font-size: 36px !important;
}
.el-collapse-item .el-collapse-item__header {
  color: #000000 !important;
  font-size: 16px !important;
  font-weight: 700 !important;
}
@media screen and (max-width: 1200px) {
  #horizontalTimelineBar {
    visibility: hidden;
    display: none;
  }

  #verticalTimelineBar {
    visibility: visible;
    display: block;
  }
}

@media screen and (min-width: 1200px) {
  #horizontalTimelineBar {
    visibility: visible;
    display: block;
  }

  #verticalTimelineBar {
    visibility: visible;
    display: none;
  }
}
.grid-container {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-rows: auto auto;
  grid-gap: 10px;
  background-color: #2196F3;
  padding: 10px;
}

.grid-container > div {
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 20px 0;
  font-size: 30px;
}
.btn{
  padding: 2rem 5rem !important;
}

.btn-theme {
  background-color: #ceff13 !important;
  color: #0e1417 !important;
  letter-spacing: 1.2px;
}

.btn-other {
  background-color: #63b3f4;
  color: #fff;
  letter-spacing: 1.2px;
  border-radius: 10rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1rem;
  height: 40px;
}

p .texxt {
  font-size: 26px !important;
}

.btn h2 {
  font-weight: 900 !important;
  line-height: 1.5;
}
.benefit-item img {
  display: block;
  border-radius: 0.6rem;
  height: 194px;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: center;
  object-position: center;
  margin: 0 0 2rem;
}
.benefit-item .title {
  color: #0e1417;
  font-size: 1.6rem;
  margin: 0 0 1.5rem;
}
.benefit-item .short-description {
  color: #6e6e6e;
  font-size: 1.1rem;
  margin: 0;
}
.el-select .el-input__inner {
  border-radius: 30px;
  margin-top: 0.15rem;
  padding: 0px 30px 0px 15px;
}
.col-12 label {
  color: #707070;
  font-weight: 400;
  font-size: 1rem;
  letter-spacing: 0.03rem;
  margin-left: 1.2rem;
}
.col-4 .benefit-item {
  padding-right: 20px;
  padding-left: 15px;
}
.col-12 {
  margin: 0px 0px 2.2px;
}
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
.el-loading-spinner .path {
  stroke: #000 !important;
}

.el-loading-mask {
  background: transparent !important;
}
}
footer .layer-1 .container .wrapper {
  height: 5px;
  min-height: 5px;
}
@media (max-width: 767px) {
  footer .layer-1 .container .wrapper {
    height: 0;
    min-height: 0;
    margin: 0 0 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/PaymentStartNow.vue